<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
</link>
<template>
  <v-container>
    <!-- <v-layout text-center wrap> -->
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>会員バーコード</h4>
        </span>
      </span>
      <span id="header_logo"><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px" /></span>
      <span id="hamburger_menu" @click="preferences"><i class="fa fa-bars fa-3x fa-fw" title="設定画面を開く"></i></span>
      <v-flex xs12 id="area_kaiinsyo">
        <br />
        <h2><span id="shop_name" hidden>{{ $shopname }}</span></h2>
        <br />
        お会計の際にこの画面をご提示ください
        <br />
        <br />
        <div class="ma-4" id="progress_ring">
          <!--  modal プログレスリング表示 modal-p   -->
          <div class="modal js-modal-p" style="margin-left:0px">
            <div class="modal__bg js-modal-close"></div>
            <div class="modal__content_p">
              <div class="progress_ring">
                <br /><br />
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
                &ensp;読込中...&ensp;
                <br />
              </div>
            </div><!--modal__inner-->
          </div><!--modal__inner-->
          <span id="copyright">
          </span>
          <!--modal modal-p -->
        </div>
        <img id="main_link" alt="（みせめぐアプリ内で会員証が削除されました）" />
        <!-- <br />
        <br /> -->
        <span id="member_info"></span>
        <!-- <br />
        <br />
       <br />
        <br /> -->
        <span id="shopid" hidden></span>
        <span id="member_info2" hidden></span>
        <!-- 0017083 -->
        <span id="misemeg_uid" hidden></span>
        <span id="mail_address" hidden></span>
      </v-flex>
      <v-flex mb-4 xs12 id="area_mobile_order">
        <br />
        <h2><span id="shop_name" hidden>{{ $shopname }}</span></h2>
        <br />
        <div class="ma-4">
          <v-btn @click="mobileorder" title="モバイルオーダー画面を表示します" id="mobileorder_btn" hidden>モバイルオーダー</v-btn>
        </div>
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12 id="area_button_array">
        <table id="btn_array" cellpadding=5>
          <tr>
            <td class="array_buttons" colspan="4" @click="purchases" title="購入履歴を表示します" id="purchases_btn">
              購入履歴
            </td>
          </tr>
          <tr>
            <td class="array_buttons_s3" @click="recomendation" title="おすすめ情報を表示します" id="recomendation_btn">
              <i class="fa fa-star fa-lg fa-fw"></i><br />
              おすすめ
            </td>
            <td class="array_buttons_s3" @click="storeslist" title="店舗一覧情報を表示します" id="storeslist_btn">
              <i class="fa fa-store fa-lg fa-fw"></i><br />
              店舗一覧
            </td>
            <td class="array_buttons_s3" @click="pm_list" title="プッシュ通知一覧を表示します" id="pm_list_btn">
              <i class="fa fa-info fa-lg fa-fw"></i><br />
              お知らせ
            </td>
          </tr>
        </table>
      </v-flex>
      <!-- Snackbar -->
      <div>
        <v-snackbar v-model="snackbarFlag" color="primary" multi-line :timeout="snackbarTimeout" top>
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <v-flex mb-4 xs12>
        <div class="ma-4">
          <img id="miniapp_qr" src="../assets/QR_1660679486-ezA66NjQ.png" width="200px" />
          <br />
          <br />
          <v-btn large color="info" @click="shareLINE" id="line_share_btn">この会員証を友だちに紹介する</v-btn>
        </div>
      </v-flex>
      <v-flex mb-4 xs12>
        <div class="ma-4">
          <br />
          <br />
          <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy;
              BUSICOM.Co.,ltd. </a><br />&emsp;v2.5.0.1&emsp;</span>
        </div>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<style>
body {
  background-color: #f3f3f3;
}

.v-main {
  background-color: #f3f3f3;
}

#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}

#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}

#header_logo {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  margin-left: 0px;
  margin-right: 100px;
}

@media screen and (max-width: 600px) {
  #hamburger_menu {
    margin-top: -58px;
    padding-left: 84%;
    color: #f3f3f3;
  }
}

@media screen and (min-width: 601px) and (max-width: 964px) {
  #hamburger_menu {
    margin-top: -58px;
    padding-left: 90%;
    color: #f3f3f3;
  }
}

@media screen and (min-width: 965px) {
  #hamburger_menu {
    margin-top: -58px;
    padding-left: 88%;
    color: #f3f3f3;
  }
}

#main_link {
  visibility: hidden;
  text-align: center;
  display: fixed;
  color : #777;
  background-color: transparent;
  width: 67%;
  height: 19%;
  min-height: 65px;
  margin-left: 0px;
}

#member_info_tbl {
  margin: 0 auto;
  color: navy;
  text-align: left;
  width: 30%;
  white-space: nowrap;
}

#point_info_tbl {
  margin: 0 auto;
  color: #000;
  text-align: left;
  width: 30%;
  white-space: nowrap;
}

#point_row {
  text-align: center;
}

#point_num {
  color: tomato;
}

.pt_inf {
  /*
  display: none;
  color : transparent;
  */
  font-weight: bold;
  margin-bottom: 2%;
}

.fa_white {
  color: #f3f3f3;
}

#area_button_array {
  /* 左右中央寄せ */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
}

#btn_array {
  width: 90%;
  background: #4caf50;
  color: #f3f3f3;
  text-align: center;
  vertical-align: middle;
  border: 2px solid #f3f3f3;
  border-collapse: collapse;
}

.array_buttons {
  width: 100%;
  height: 65px;
  background: #4caf50;
  color: #eee;
  text-align: center;
  vertical-align: middle;
  border-top: 2px solid #f3f3f3;
  border-left: 2px solid #f3f3f3;
  border-right: 2px solid #f3f3f3;
  border-bottom: 15px solid #f3f3f3;
  border-collapse: collapse;
}

.array_buttons_s3 {
  width: 33%;
  height: 100px;
  background: #4caf50;
  color: #eee;
  text-align: center;
  vertical-align: middle;
  border: 2px solid #f3f3f3;
  border-collapse: collapse;
}

#line_logout {
  margin: 0 auto;
}

#mobileorder_btn {
  height: 100px;
  width: 88%;
  color: #f3f3f3;
  background-color: #2f4f4f;
  font-weight: normal;
}

#member_info {
  margin-top: 100px;
}

#tvmembcode {
  /* display:block; */
  text-align: center;
  margin-top: -30px;
  padding-left: 30px;
  /* margin-left: auto;
  margin-right: auto; */
  font-size: x-large;
  font-weight: bold;
}

#purchases_btn {
  /* width: 70%; */
  font-size: large;
  letter-spacing: 0.3em;
  margin-top: 5%;
  margin-bottom: 5%;
}

#slip_viewer_btn {
  width: 70%;
  font-size: large;
  letter-spacing: 0;
}

#kickmisemeg_btn {
  width: 70%;
  font-size: large;
  letter-spacing: 0;
}

#kickmisemeg_hp_btn {
  width: 70%;
  font-size: large;
  letter-spacing: 0;
}

#recomendation_btn {
  /* width: 70%; */
  font-size: middle;
  letter-spacing: 0.2em;
  line-height: 2;
}

#storeslist_btn {
  /* width:70%; */
  font-size: large;
  letter-spacing: 0.2em;
  line-height: 2;
}

#mobileorder_btn {
  /* width:70%; */
  font-size: large;
  letter-spacing: 0;
}

#pm_list_btn {
  /* width: 70%; */
  font-size: large;
  letter-spacing: 0.2em;
  line-height: 2;
}

#line_share_btn {
  width: 70%;
  font-size: middle;
  letter-spacing: 0.0em;
}

#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

.container {
  background-color: #f3f3f3;
  /* width:90%; */
}

#user_maintenance {
  font-size: x-small;
  color: #c0c0c0;
  text-decoration: underline;
}

#user_information {
  font-size: small;
  color: #fff;
  background: #808080;
  border: 1px solid #808080;
  border-radius: 5px;
  padding: 5px 10px;
  letter-spacing: 0.5em;
  text-decoration: none;
}
</style>
<script>
// for encrypt message
import crypto from 'crypto-js';
var CryptoJS = require('crypto-js');
// var dts = new Date().getDate();
var dts = '651127';
var passPhrase = "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";
//初回アクセスフラグ
var init_flg = false;

// for HTTP response
import axios from 'axios'
// メルアド取得エラーカウンター
var lgnerr = 0;

export default {
  data () {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      name: '',
      imgURL: '',
      userId: '',
      email: '',
      sub: '',
      barcode_url: '',
      inClient: false
    }
  },
  async created () {
     await this.initializeLiff();
     // $('#main_title').css('width',window.outerWidth); 
  },
  mounted(){
    // ページ描画完了後の処理
    window.setTimeout(() => {          
      $("#purchases_btn").show();
      $("#slip_viewer_btn").show();
      $("#recomendation_btn").show();
      $("#storeslist_btn").show();
      $("#pm_list_btn").show();
      //this.non_tv_disp();
      //0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
      $("#purchases_btn").prop('disabled', false);
      $("#recomendation_btn").prop('disabled', false);
      $("#storeslist_btn").prop('disabled', false);
      $("#pm_list_btn").prop('disabled', false);
    }, 1000); // <-- 1sec timer
    $('#main_title').css('width',window.outerWidth); 
  },
  methods: {
    non_tv_disp: function () {
      // TenpoVisor契約無しの場合の非表示設定
      $('#point_row').css('display','none');
      $('#point_num').css('display','none');
      $('.pt_inf').css('display','none');
      $('#area_user_information').css('display','none');
      $("#area_kaiinsyo").css('margin-bottom','-150px');
    },
    initializeLiff: function () {
      var me = this
      liff.init(
        {
            liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          me.loginCheck()
        },
        err => {
          console.log('LIFF initialization failed', err)
        }        
      )
    },
    loginCheck: async function () {
      var me = this
      //ログインエラーカウントのクリア
      // lgnerr = 0;
      // localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid=this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if(debug_mode == '2'){
        miseid=this.$_shopid();
      }
      // md5()実行用ライブラリ読込
      var md5 = require('md5');
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth()+1;
      var strMonth='';
      if(month<10){
        strMonth = '0' + month;
      }else{
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = '';
      if(date<10){
        strDate = '0' + date;
      }else{
        strDate = date.toString();
      }
      var mmddyyyy= strMonth + '-' + strDate + '-' + year;
      // ログインチェック
      if (liff.isLoggedIn()) {
        this.isClient = liff.isInClient();
        const permissionStatus = await liff.permission.query("email");
        // window.alert('#327 : permissionStatus.state=' + permissionStatus.state);
        debugger;
        if (permissionStatus.state === "prompt") {
          init_flg = true;  
          try{
            await liff.permission.requestAll();
          }catch(Exception){
            // this.$router.push({ name: 'login' });     
          }         
        }
        const idToken = await liff.getDecodedIDToken();
        // const idToken = await liff.getDecodedIDToken();

        // LIFFプロフィール取得
        await liff.getProfile()
          .then(profile => {
            me.name = profile.displayName
            me.imgURL = profile.pictureUrl
            me.userId = profile.userId
            me.email = idToken.email 
            me.sub = idToken.sub           
            me.barcode_img = barcode_url
            debugger;            
          })
          .catch((err) => {
            console.log('error', err)
          })

        // メルアド,SUBとグローバル変数の店舗IDを取得
        // 0017083 ログイン状態判定方法を修正 {（０）LINEアカウントからidToken.mailを取得 （１）LocalStorageからmail取得 → （２）DBからmail取得 }
        // LINEアカウントから idToken.mail と idToken.sub を取得
        var email =idToken.email;
        // window.alert('loginCheck() idToken.email = ' + idToken.email);
        var sub = idToken.sub;
        var muid = '';
        //(1)idToken からメールが取得出来ない場合はlocalStorageに保存したメルアド情報を取得する
        try{
          if(email=='undefined'||email==null||email==''){
              var ls_mail = localStorage.getItem('lmmini_' + dts + '_maddr');
              const decrypted_email =CryptoJS.AES.decrypt(ls_email, key, {iv: iv,});
              email = decrypted_email.toString(CryptoJS.enc.Utf8);
          }
        }catch(Exception){
          email = null;
        }
        
        // window.alert('name=' + me.name + ' : pictureUrl=' + me.imgURL);
        //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
        var miseid=this.$_t_shopid();
        //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
        if(debug_mode == '2'){
          miseid=this.$_shopid();
        }
        //オーナーIDをグローバル変数から取得する（※初期値は試験用）
        var prmid=this.$_t_prmid();
        //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
        if(debug_mode == '2'){
          prmid=this.$_prmid();
        }
        //0014906: 【みせめぐ】LINEミニアプリでLINEアカウントにメルアドが未設定の場合に登録画面がループ表示される件の対策        
        try{
          lgnerr =localStorage.getItem('lmmini_' + dts + '_lgnerr');
          // alert('664  lgnerr(from LS)  = ' + lgnerr);
        }catch(Exception){
            lgnerr = null;
        }
        
        //ログインエラーカウンターがnullの場合は0を設定してLocalStorageに保存する
        if(lgnerr==null){
          // alert('670 lgnerr clear');
          lgnerr = 0;
          localStorage.setItem('lmmini_' + dts + '_lgnerr',lgnerr);
        }
        //(1)idToken からmuidが取得出来ない場合はlocalStorageに保存したメルアド情報を取得する
        try{
          var ls_muid = localStorage.getItem('lmmini_' + dts + '_muid');
          if(ls_muid){
            const decrypted_muid =CryptoJS.AES.decrypt(ls_muid, key, {iv: iv,});
            muid = decrypted_muid.toString(CryptoJS.enc.Utf8);
          } 
        }catch(Exception){
          muid = null;
        }
        // メールアドレスとみせめぐユーザーIDが取得できた場合はここで会員証表示に進む
        if(email!='undefined' && email!=null && email!='' && muid!='undefined' && muid!=null && muid!=''){
            //--------------------------------------------
            // <0> 会員証情報HTMLの取得と表示(USERIDベース)
            //--------------------------------------------
            var codeinfo_url ="";
            var debug_mode = this.$_debug_mode();
            //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にsv1/sv2固定にする
            var i_shopid=Number(this.$_shopid());
            if(debug_mode=='0'){
              codeinfo_url = this.$_debug_url();
            }else if(debug_mode=='2'){
              if(i_shopid % 2 == 0){
                codeinfo_url = "https://sv2.misemeg.jp/";
              }else{
                codeinfo_url = "https://sv1.misemeg.jp/";
              }
            }else{
              if(i_shopid % 2 == 0){
                codeinfo_url = "https://sv2.misemegu.jp/";
              }else{
                codeinfo_url = "https://sv1.misemegu.jp/";
              }
            }
            //0015340 ポイント共有フラグ(有効=1 , 無効=0)
            var point_share_flg = '0';
            try{
              point_share_flg = this.$_tv_pointshare();
            }catch(Exception){
              point_share_flg = '0';
            }
            var tv_shop_array = '0';
            if(debug_mode=='2'){
              try{
                tv_shop_array = this.$_tv_shop_array()
              }catch(Exception){
                tv_shop_array = '0';
              }
            }else{
              try{
                tv_shop_array = this.$_t_tv_shop_array()
              }catch(Exception){
                tv_shop_array = '0';
              }
            }
            //店舗オーナーID
            //オーナーIDをグローバル変数から取得する（※初期値は試験用）
            var prmid=this.$_t_prmid();
            //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
            if(debug_mode == '2'){
              prmid=this.$_prmid();
            }
            codeinfo_url += "appli/line/"
            codeinfo_url += "getMembershipCodeInfoHTML3spnm.php?uid=";
            codeinfo_url += muid;
            codeinfo_url += "&shopid=";
            codeinfo_url += miseid;
            codeinfo_url += "&prmid=";
            // 店舗選択の可能性があるサイトはprmid
            codeinfo_url += prmid;
            //0015340 ポイント共有フラグ param[psh]
            codeinfo_url += "&psh=";
            codeinfo_url += point_share_flg;
            //TV店舗配列
            codeinfo_url += "&tvshps=";
            codeinfo_url += btoa(tv_shop_array);
            //ポイント有効期限表示フラグ
            codeinfo_url += "&pev=";
            codeinfo_url += this.$_point_expiration_view(); 
            codeinfo_url += "&security=" + md5(muid + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + muid + "!Busicom04510" + mmddyyyy);  
            // window.alert('getMemInf = ' + codeinfo_url);     
            await axios.get(codeinfo_url)
            //.then((response) => this.users = response.data)
            .then((response) => document.getElementById('member_info').innerHTML = response.data)
            .catch(error => console.log(error))
            ;
        }else{
            /**
             * みせめぐユーザーIDが取得できない場合は現状のメールベースの処理を行う
             */
            //(3)idtokenからもlocalStroageからもDBからも取得できなかった場合はログイン画面に遷移する（リロードして再度idToken.emailを取得）
            if(email=='undefined'||email==null||email==''){
               
                if (liff.isLoggedIn()) {
                  //0014906: 【みせめぐ】LINEミニアプリでLINEアカウントにメルアドが未設定の場合に登録画面がループ表示される件の対策
                  // エラーカウンターを++してlocalStorageに記録
                  // window.alert('#372 加算前 : lgnerr=' + miseid + ' : ' + lgnerr);
                  lgnerr = Number(lgnerr) + 1;
                  // window.alert('#374 加算後 : lgnerr=' + miseid + ' : ' + lgnerr);
                  if(miseid==null||miseid==''){
                    //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
                    miseid=this.$_t_shopid();
                    //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
                    var debug_mode = this.$_debug_mode();
                    if(debug_mode == '2'){
                      miseid=this.$_shopid();
                    }
                  }
                  localStorage.setItem('lmmini_' + dts + '_lgnerr',lgnerr);

                  //メルアド取得エラーカウンターが3回を超えている（4回目以降）場合はエラー画面に遷移させる
                  if(Number(lgnerr)>4){
                    // ログアウト
                    if (liff.isLoggedIn()) {
                      //エラーカウンターをクリア
                      //alert('835 lgnerr clear');
                      lgnerr = 0;
                      localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                      //LocalStorageのクリア
                      this.user_maintenance_ss();
                      window.alert('エラーが発生しました。しばらくしてから再度お試しください\nLINEのアカウント設定でメールアドレスが登録されているかご確認ください。815');
                      window.setTimeout(() => {
                        this.$router.push({ name: 'error_view' });
                      }, 1000)
                    }
                  
                  }
                  else{
                     if (liff.isLoggedIn()) {
                       window.setTimeout(() => {  
                        liff.logout();        
                        //ホーム画面に遷移させる （※ユーザー同意が完了・反映されてメルアドが取れる状態で再ログインできることを期待）
                        // window.alert('#616');
                        this.$router.push({ name: 'home' });
                      }, 500); // <-- 500mSec timer
                    }
                  }
                }
            }
 
        //----------------------------------------------------------
        // <B0> 登録時に選択した店舗IDの情報がWebStorageにあれば取得する
        //----------------------------------------------------------
        //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
        var g_miseid=this.$_t_shopid();
        //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
        var debug_mode = this.$_debug_mode();
        if(debug_mode == '2'){
          g_miseid=this.$_shopid();
        }
        var encrypted_myshopid = localStorage.getItem('lmmini_' + dts + '_myshopid');
        if(encrypted_myshopid){
          const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {iv: iv,});
          var myshopid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
          if(myshopid){
            miseid=myshopid;
          }else{
            miseid=g_miseid;
          }
        }else{
          miseid=g_miseid;
        }
          // window.alert('email:' + email);
          // window.alert('miseid:' + miseid);
          //--------------------------------------------------------------------------
          // <0> [LINE_TMP]テーブルにメルアド・性別・都道府県の情報があればDBを更新する
          //--------------------------------------------------------------------------
          try{
              var md5 = require('md5');
              var debug_mode = this.$_debug_mode();
              var user_ext_url ="";
              //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にsv1/sv2固定にする
              var i_shopid=Number(this.$_shopid());
              if(debug_mode=='0'){
                user_ext_url = this.$_debug_url();
              }else if(debug_mode=='2'){
                if(i_shopid % 2 == 0){
                  user_ext_url = "https://sv2.misemeg.jp/";
                }else{
                  user_ext_url = "https://sv1.misemeg.jp/";
                }
              }else{
                if(i_shopid % 2 == 0){
                  user_ext_url = "https://sv2.misemegu.jp/";
                }else{
                  user_ext_url = "https://sv1.misemegu.jp/";
                }
              }
              user_ext_url += "appli/line/"
              user_ext_url += "extendUserInfo.php?uid=&mail=";
              user_ext_url += idToken.email;
              user_ext_url += "&security=" + md5(idToken.email  + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + idToken.email  + "!Busicom04510" + mmddyyyy);
              //user_ext_url += "&openExternalBrowser=1";
              // window.alert(user_ext_url);
              debugger;
              axios.get(user_ext_url)
              .then((response) => response.data)
              .catch(error => console.log(error))
              ; 
              //localStorageを削除（※旧処理で生成したデータが残っている場合があるため）
              localStorage.removeItem('lmmini_gender');
              localStorage.removeItem('lmmini_region');
              localStorage.removeItem('lmmini_birth_date');
          }catch(Exception){
            ;;
          }

          //--------------------------------------------
          // <1> 会員証情報HTMLの取得と表示(mailベース)
          //--------------------------------------------
          var codeinfo_url ="";
          var debug_mode = this.$_debug_mode();
          //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にsv1/sv2固定にする
          var i_shopid=Number(this.$_shopid());
          if(debug_mode=='0'){
            codeinfo_url = this.$_debug_url();
          }else if(debug_mode=='2'){
            if(i_shopid % 2 == 0){
              codeinfo_url = "https://sv2.misemeg.jp/";
            }else{
              codeinfo_url = "https://sv1.misemeg.jp/";
            }
          }else{
            if(i_shopid % 2 == 0){
              codeinfo_url = "https://sv2.misemegu.jp/";
            }else{
              codeinfo_url = "https://sv1.misemegu.jp/";
            }
          }
          //0015340 ポイント共有フラグ(有効=1 , 無効=0)
          var point_share_flg = '0';
          try{
            point_share_flg = this.$_tv_pointshare();
          }catch(Exception){
            point_share_flg = '0';
          }
          var tv_shop_array = '0';
          if(debug_mode=='2'){
            try{
              tv_shop_array = this.$_tv_shop_array()
            }catch(Exception){
              tv_shop_array = '0';
            }
          }else{
            try{
              tv_shop_array = this.$_t_tv_shop_array()
            }catch(Exception){
              tv_shop_array = '0';
            }
          }
          //店舗オーナーID
          //オーナーIDをグローバル変数から取得する（※初期値は試験用）
          var prmid=this.$_t_prmid();
          //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
          if(debug_mode == '2'){
            prmid=this.$_prmid();
          }
          codeinfo_url += "appli/line/"
          codeinfo_url += "getMembershipCodeInfoHTML2spnm.php?mail=";
          codeinfo_url += email;
          codeinfo_url += "&shopid=";
          codeinfo_url += miseid;
          codeinfo_url += "&prmid=";
          // 店舗選択の可能性があるサイトはprmid
          codeinfo_url += prmid;
          //0015340 ポイント共有フラグ param[psh]
          codeinfo_url += "&psh=";
          codeinfo_url += point_share_flg;
          //TV店舗配列
          codeinfo_url += "&tvshps=";
          codeinfo_url += btoa(tv_shop_array);
          //ポイント有効期限表示フラグ
          codeinfo_url += "&pev=";
          codeinfo_url += this.$_point_expiration_view(); 
          codeinfo_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy);  
          // window.alert('getMemInf = ' + codeinfo_url);     
          await axios.get(codeinfo_url)
          //.then((response) => this.users = response.data)
          .then((response) => document.getElementById('member_info').innerHTML = response.data)
          .catch(error => console.log(error))
          ;
        } // end of mail-mode      

        //----------------------------------------------------------------------
        // <2> バーコード画像の生成(IMGタグのSRCに設定可能な画像オブジェクトの取得)
        //----------------------------------------------------------------------
        try{
          var md5 = require('md5');
          var barcode_url ="";
          var debug_mode = this.$_debug_mode();
          //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
          var i_shopid=Number(this.$_shopid());
          if(debug_mode=='0'){
            barcode_url = this.$_debug_url();
          }else if(debug_mode=='2'){
            if(i_shopid % 2 == 0){
              barcode_url = "https://sv2.misemeg.jp/";
            }else{
              barcode_url = "https://sv1.misemeg.jp/";
            }
          }else{
            if(i_shopid % 2 == 0){
              barcode_url = "https://sv2.misemegu.jp/";
            }else{
              barcode_url = "https://sv1.misemegu.jp/";
            }
          }
          //オーナーIDをグローバル変数から取得する（※初期値は試験用）
          var prmid=this.$_t_prmid();
          //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
          if(debug_mode == '2'){
            prmid=this.$_prmid();
          }
          barcode_url += "appli/line/"
          barcode_url += "getMembershipBarcodeIMG2.php?mail=";
          //liff.getProfile()実行後に idToken.email の情報を使用してみせめぐ上の会員証バーコード生成WebAPIをキックする
          barcode_url += email;
          barcode_url += "&prmid="
          // 店舗選択の可能性があるサイトはprmid
          barcode_url += prmid;
          barcode_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy) + "&mode=png&h=60";
          debugger;
          // window.alert('barcode_url=' + barcode_url);
          // IMGタグのSRC属性を置換
          document.getElementById('main_link').src = barcode_url;
        }catch(Exception){
          ;;
        }

        //モバイルオーダー使用フラグを読み取り
        var mobile_order_flg =  this.$_mobile_order();

        //--------------------------------------
        // <3> 会員証コードをlocalStorageに書き込み
        //--------------------------------------
        var memcd = $('#c_memcode').val();  
        // window.alert('memcd = ' + memcd);
        // window.alert($('#c_memcode').val());
        //会員証コードがhidden領域に存在しない場合、みせめぐサーバー上のWebAPI処理を2秒間待機してユーザーIDと店舗コードが取得できたかどうかを確認する。
        //取得できていない場合は新会員と判断してユーザー登録画面に遷移させる。        
        window.setTimeout(() => {          
            // var org_miseid = this.$_shopid();
            // 20241115 店舗IDが"undefined"の場合は設定ファイルの値を読む
            if(miseid=='undefined'||miseid==null||miseid==''){
              //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
              miseid=this.$_t_shopid();
              //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
              var debug_mode = this.$_debug_mode();
              if(debug_mode == '2'){
                miseid=this.$_shopid();
              }
            }
            if(memcd && memcd != 'undefined'){    
              localStorage.removeItem('lmmini_' + dts + '_memcode');
              const ecrypted_memcode = CryptoJS.AES.encrypt(memcd, key, {iv: iv,}).toString();
              localStorage.setItem('lmmini_' + dts + '_memcode',ecrypted_memcode.toString());
            }
            var ls_memcode = localStorage.getItem('lmmini_' + dts + '_memcode');
            // window.alert('memcd = ' + memcd + ' : ls_memcode = ' + ls_memcode);
            //▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼
            // for debug
            // memcode = null;
            //▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲
            if(!memcd || memcd === 'undefined'){
              //プログレスリンクを非表示
              $("#progress_ring").hide();
              //会員証情報取得できない場合でregist画面に遷移しなければ「みせめぐアプリ内で会員証が削除されました」を表示する
              $("#main_link").css('visibility','visible');
                var userid = $('#c_userid').val();
                //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
                var miseid=this.$_t_shopid();
                //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
                var debug_mode = this.$_debug_mode();
                if(debug_mode == '2'){
                  miseid=this.$_shopid();
                }
                localStorage.removeItem('lmmini_' + dts + '_muid');
                const ecrypted_uid =CryptoJS.AES.encrypt(userid, key, {iv: iv,}).toString();
                localStorage.setItem('lmmini_' + dts + '_muid', ecrypted_uid);
                email = idToken.email;
                //window.alert('email = ' + email);
                if(email=='undefined'||email==null||email==''){
                  if(liff.isLoggedIn){
                    lgnerr = Number(lgnerr) + 1;
                    // alert('lgnerr=' + lgnerr);
                    localStorage.setItem('lmmini_' + dts + '_lgnerr',lgnerr);
                    if(lgnerr < 4 ){
                      window.setTimeout(() => {  
                        liff.logout();
                        this.$router.push({ name: 'home' }); 
                      }, 500);  
                    }else{
                      // エラーカウンタークリア
                      // alert('1116 lgnerr clear');
                      lgnerr = 0;
                      localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                      // alert('clear 1115 init_flg = ' + init_flg + ' : email = ' + email);
                      // ログインエラーで登録画面への遷移が3回を超えていればエラー画面に遷移
                      if (liff.isLoggedIn()) {
                        if(email!='undefined' && email!=null && email!=''){
                            // エラーカウンタークリア
                            // lgnerr = 0;
                            // localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                            // 初回アクセスであれば新規登録ページ(/regist_selecter) に遷移
                            this.$router.push({ name: 'regist_selecter' });
                        }else{                          
                          //localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                          //LocalStorageのクリア
                          this.user_maintenance_ss();
                          window.alert('エラーが発生しました。しばらくしてから再度お試しください\nLINEのアカウント設定でメールアドレスが登録されているかご確認ください。1122 : ' + lgnerr);                      
                          window.setTimeout(() => {
                            this.$router.push({ name: 'error_view' });
                          }, 1000);
                        }
                      }
                    }
                  }
                }else{
                  if (lgnerr==null||lgnerr==''){
                    // alert('1150 lgnerr clear');
                    lgnerr = 0;            
                  }
                  lgnerr = Number(lgnerr) + 1;
                  //エラーカウントを数値化して例外が出れば予期せぬ値が入るのを防ぐために1（エラー発生初回と見做す）を設定
                  try{
                    var chkerr = Number(lgnerr);
                  }catch(Exception){
                    lgnerr = 1;
                  }
                  // window.alert('[1092] lgnerr=' + lgnerr);
                  // window.alert('[872] lgnerr=' + lgnerr);
                  localStorage.setItem('lmmini_' + dts + '_lgnerr',lgnerr);
                  if(lgnerr < 4 && (email!='undefined' && email!=null && email!='')){
                    // エラーカウンタークリア
                    // alert('1165 lgnerr clear');
                    lgnerr = 0;
                    localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                    // ログインエラーで登録画面への遷移が3回を超えていなければ新規登録ページ(/regist) に遷移 
                    this.$router.push({ name: 'regist_selecter' });     
                  }else{
                    // エラーカウンタークリア
                    // alert('1172 lgnerr clear');
                    lgnerr = 0;
                    localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                    // ログアウト
                    if (liff.isLoggedIn()) {
                      if(email!='undefined' && email!=null && email!=''){
                        //if(init_flg==true && (email!='undefined' && email!=null && email!='')){
                            // 初回アクセスであれば新規登録ページ(/regist_selecter) に遷移
                            this.$router.push({ name: 'regist_selecter' });
                        }else{                          
                          //localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
                          //LocalStorageのクリア
                          this.user_maintenance_ss();
                          window.alert('エラーが発生しました。しばらくしてから再度お試しください\nLINEのアカウント設定でメールアドレスが登録されているかご確認ください。1122');                      
                          window.setTimeout(() => {
                            this.$router.push({ name: 'error_view' });
                          }, 1000);
                        }
                    }
                  }
                }      
            }else{
              // エラーカウンタークリア
              // alert('1194 lgnerr clear');
              lgnerr = 0;
              localStorage.setItem('lmmini_' + dts + '_lgnerr',0);
              // window.alert('[debug] 663else');
              //プログレスリンクを非表示
              $("#progress_ring").hide();
              // 店名を表示する
              $("#shop_name").show();
              //バーコードを表示する
              $("#main_link").css('visibility','visible');
            }
          // }, 4000); // <-- 4sec timer 
          }, 400); // <-- 400 millisec timer 
          // 会員証画像サイズの最大化
          $('#card_img img').css('width','100%');
          // 0015995: ミニアプリのバーコード上部の店舗名に固定文字列ではなくカードを発行した店舗の店舗名を表示する
          document.getElementById('shop_name').innerHTML = $('#c_shopnm').val();

        //-----------------------------------------------------------------------------------------
        // <4> モバイルオーダー使用設定でデジタル会員証とモバイルオーダーボタンの表示・非表示を切り替える
        //-----------------------------------------------------------------------------------------
        if(mobile_order_flg=='1'){
            $('#area_kaiinsyo').hide();
            $('#area_bought_history').hide();
            $('#area_slip_viewer').hide();
            $('#area_mobile_order').show();
            $('#mobileorder_btn').show();
            $('#main_title').html('<h4>&emsp;モバイルオーダー</h4>')
        }else{
            $('#area_kaiinsyo').show();
            $('#area_bought_history').show();
              $('#area_slip_viewer').show();
            $('#area_mobile_order').hide();
            $('#mobileorder_btn').hide();
            $('#main_title').html('<span id="main_title_text"><h4>会員バーコード</h4></span>')
        }

      } else {
        // ログインまだ
        // alert('903');
        this.$router.push({ name: 'home' })
      }
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout();
        // alert('911');
        this.$router.push({ name: 'home' })
      }
    },
    purchases: function () {
      // 購入履歴照会・表示ボタン
      // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
      $('#purchases_btn').prop('disabled',true);
      $('#purchases_btn').css('display','none');
      // 購入履歴画面に遷移
      this.$router.push({ name: 'purchases' })
    },
    slip_viewer: function () {
      // 電子レシート照会・表示ボタン
      var me = this
      // md5()実行用ライブラリ読込
      var md5 = require('md5');
      var slip_url ="";
      var debug_mode = this.$_debug_mode();
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にsv1/sv2固定にする
      var i_shopid=Number(this.$_shopid());
      if(debug_mode=='0'){
        slip_url = this.$_debug_url();
      }else if(debug_mode=='2'){
        if(i_shopid % 2 == 0){
          slip_url = "https://sv2.misemeg.jp/";
        }else{
          slip_url = "https://sv1.misemeg.jp/";
        }
      }else{
        if(i_shopid % 2 == 0){
          slip_url = "https://sv2.misemegu.jp/";
        }else{
          slip_url = "https://sv1.misemegu.jp/";
        }
      }
      slip_url += "appli/line/"
      // for PC debug
      // slip_url = 'http://localhost/mg/appli/line/';
      // parameters生成
      //TenpoVisor会社コードをグローバル変数から取得する（※初期値は試験用）
      var tv_compcd = this.$_t_tv_compcd();
      //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
      if(debug_mode == '2'){
        tv_compcd = this.$_tv_compcd();
      }
      //TenpoVisor会社コードをグローバル変数から取得する（※初期値は試験用）
      var tv_shopcd = this.$_t_tv_shopcd();
      //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
      if(debug_mode == '2'){
        tv_shopcd = this.$_tv_shopcd();
      }
      var tv_custcd = $('#c_memcode').val();
      var b64_tv_compcd = btoa(tv_compcd);
      var b64_tv_shopcd = btoa(tv_shopcd);
      var b64_tv_custcd = btoa(tv_custcd);
      var direction = "";
      //電子レシート表示用トークンは24時間制限無し（ハッシュ値照合OKであれば無期限）とする
      var security = md5(tv_compcd  + "5ca968c5c9c793ad75b49ac19b493ad2misemegLine" + tv_compcd  + "!Busicom04510");
      slip_url += "receiptViewer.php?tv_compcd=" + btoa(tv_compcd) + "&tv_shopcd=" + btoa(tv_shopcd) + "&tv_custcd=" + btoa(tv_custcd) + "&direction=" + direction + "&security=" + security;
      // 別ウィンドウで開く
      // window.alert('slip_url=' + slip_url);
      window.open(slip_url,'_blank');
    },
    recomendation: function () {
      // おすすめ情報照会・表示ボタン
      // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
      $('#recomendation_btn').prop('disabled',true);
      $('#recomendation_btn').css('display','none');
      // おすすめ情報画面に遷移
      this.$router.push({ name: 'recomendation' })
    },
    storeslist: function () {
      // 店舗一覧情報照会・表示ボタン
      // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
      $('#storeslist_btn').prop('disabled',true);
      $('#storeslist_btn').css('display','none');
      // 店舗一覧画面に遷移
      this.$router.push({ name: 'stores' })
    },
    pm_list: function () {
      // プッシュ通知一覧情報照会・表示ボタン
      // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
      $('#pm_list_btn').prop('disabled',true);
      $('#pm_list_btn').css('display','none');
      this.$router.push({ name: 'pm_list' })
    },
    preferences: function () {
      // 環境設定画面・表示ボタン
      this.$router.push({ name: 'preferences' })
    },
    kickmisemeg: function () {
      if (liff.isLoggedIn()) {
        // みせめぐアプリ(iOS/Android)起動      
        this.$router.push({ name: 'kickmisemeg' });
      }
    },
    kickmisemeg_hp: function () {
      if (liff.isLoggedIn()) {
        // みせめぐ紹介ページに遷移   
        this.$router.push({ name: 'kickmisemeg_hp' });
      }
    },
    mobileorder: function () {
      if (liff.isLoggedIn()) {
        // モバイルオーダーページに遷移   
        var userid = $('#c_userid').val();
        //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
        var miseid=this.$_t_shopid();
        //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
        var debug_mode = this.$_debug_mode();
        if(debug_mode == '2'){
          miseid=this.$_shopid();
        }
        localStorage.removeItem('lmmini_' + dts + '_muid');
        const ecrypted_uid =CryptoJS.AES.encrypt(userid, key, {iv: iv,}).toString();
        localStorage.setItem('lmmini_' + dts + '_muid', ecrypted_uid);
        this.$router.push({ name: 'mobileorder' });
      }
    },
    user_maintenance: function () {
      if (window.confirm("ミニアプリのユーザー情報をクリアしてもよろしいですか？")) {
        //20230926 lmmini_で始まるキーを持った全項目を削除するように修正。
        for (var i = 0; i < localStorage.length; i++) {
           var key = localStorage.key(i);
           if (key.indexOf('lmmini_') > -1){
            // if (key.indexOf('lmmini_') > -1 || key.indexOf('LIFF_STORE') > -1){
             localStorage.removeItem(key);
           }
        }
        window.alert('自動で再起動しない場合は画面右上の「×」を押してミニアプリを終了後もう一度起動してください');
        liff.logout();
        this.$router.push({ name: 'home' });
      }
    },
    user_maintenance_s: function () {
      // ユーザー情報クリア
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid=this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if(debug_mode == '2'){
        miseid=this.$_shopid();
      }
      localStorage.removeItem('lmmini_' + dts + '_memcode');
      localStorage.removeItem('lmmini_' + dts + '_maddr');
      localStorage.removeItem('lmmini_' + dts + '_muid');
      localStorage.removeItem('lmmini_' + dts + '_myshopid');
      var encrypted_myshopid = localStorage.getItem('lmmini_' + dts + '_myshopid');
      if(encrypted_myshopid){
        const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {iv: iv,});
        var myshopid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
        if(myshopid){
            localStorage.removeItem('lmmini_' + myshopid + '_memcode');
            localStorage.removeItem('lmmini_' + myshopid + '_maddr');
            localStorage.removeItem('lmmini_' + myshopid + '_muid');
            localStorage.removeItem('lmmini_' + myshopid + '_myshopid');
        }
      }  
    },
    user_maintenance_ss: function () {
      // ユーザー情報クリア
      //20230926 lmmini_で始まるキーを持った全項目を削除するように修正。
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key.indexOf('lmmini_') > -1){
          localStorage.removeItem(key);
        }
      }
    },
    shareLINE: function () {
      var me = this
      // LINEに送る
      liff.shareTargetPicker([
      {
        "type": "flex",
        "altText": "みせめぐMiniアプリのリンクがシェアされました",
        "contents": {
          "type": "bubble",
          "hero": {
            "type": "image",
            "url": "https://misemeg.jp/uimg/47827",
            "size": "full",
            "aspectRatio": "20:13",
            "aspectMode": "cover",
            "action": {
              "type": "uri",
              "uri": "https://miniapp.line.me/1660679486-ezA66NjQ"
            }
          },
          "body": {
            "type": "box",
            "layout": "vertical",
            "contents": [
              {
                "type": "text",
                "text": "misemeg wear",
                "weight": "bold",
                "size": "xl",
                "align": "center"
              },
              {
                "type": "box",
                "layout": "vertical",
                "margin": "lg",
                "spacing": "sm",
                "contents": []
              }
            ]
          },
          "footer": {
            "type": "box",
            "layout": "vertical",
            "spacing": "sm",
            "contents": [
              {
                "type": "button",
                "style": "link",
                "height": "sm",
                "action": {
                  "type": "uri",
                  "label": "会員証発行はこちらから",
                  "uri": "https://miniapp.line.me/1660679486-ezA66NjQ"
                }
              },
              {
                "type": "box",
                "layout": "vertical",
                "contents": [],
                "margin": "sm"
              }
            ],
            "flex": 0
          }
        }
      }
      ],
      {
        isMultiple: true,
      }
      )
      .then(() => {
        console.log('message sent');
        me.showSnackbar("LINEにシェアしました")
      })
      .catch((err) => {
        console.log('error', err)
        me.showSnackbar("LINEにシェア失敗しました")
      })
    }, 
    showSnackbar(text) {
      this.snackbarFlag = true
      this.snackbarText = text
      setTimeout(()=> {
          this.snackbarFlag = false
          this.snackbarText = ''
        },
        this.snackbarTimeout
      )
    }

  }
}
// JANコードのチェックディジット計算
function calcJanCodeDigit(num) {
    var arr = num.split('');
    var odd = 0;
    var mod = 0;
    for (var i = 0; i < arr.length; i++) {
        if (!isFinite(arr[i])) return '';
        if ((i + 1) % 2 == 0) {
            //偶数の総和
            mod += parseInt(arr[i]);
        } else {
            //奇数の総和
            odd += parseInt(arr[i]);
        }
    }

    //偶数の和を3倍+奇数の総和を加算して、下1桁の数字を10から引く
    var cd = 10 - parseInt(new String((mod * 3) + odd).substr(-1));
    //10なら1の位は0なので、0を返す。
    return cd === 10 ? 0 : cd;
}
</script>
